import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import LastAnswerByType from "../LastAnswerByType";
import models from "../../../../types/models";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default observer(function LastAnswer({ card, className }) {
  LastAnswer.propTypes = {
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
    className: PropTypes.string,
  };
  const { t } = useTranslation();
  const cls = [];
  if (className) cls.push(className);
  return (
    <>
      {card.answer && (
        <LastAnswerByType
          typeAnswer={card.answer.answer}
          className={`in-game-page__main__swipe-wrapper__wrapper__your-last-answer ${cls.join(
            " "
          )}`}
          title={t("compromise_game.your_answer")}
        />
      )}
      {card.partnerAnswer && (
        <LastAnswerByType
          typeAnswer={card.partnerAnswer.answer}
          className={`in-game-page__main__swipe-wrapper__wrapper__partner-last-answer ${cls.join(
            " "
          )}`}
          title={t("compromise_game.partner_answer")}
        />
      )}
    </>
  );
});
